import React, { FC } from 'react';
import { StaticImage } from 'gatsby-plugin-image';

interface Props {
  alt?: string;
  className?: string;
}

export const PostPlaceholderImage: FC<Props> = ({ alt = '', className = '' }) => {
  return <StaticImage aspectRatio={1.35} className={className} src="./assets/placeholder.png" alt={alt} />;
};

export default PostPlaceholderImage;
